import { createSelector } from 'reselect';
import { getUnattendedOperator } from './getUnattendedOperator';

const getUnattendedOperatorPersonId = createSelector(
  [getUnattendedOperator],
  (unattendedOperator) => {
    return unattendedOperator?.erpId || null;
  }
);

export { getUnattendedOperatorPersonId };
